import { render, staticRenderFns } from "./VImage.vue?vue&type=template&id=3319612f&"
import script from "./VImage.vue?vue&type=script&lang=js&"
export * from "./VImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/parker/lets_code/frances-valentine/new-fv-original/FV-original/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3319612f')) {
      api.createRecord('3319612f', component.options)
    } else {
      api.reload('3319612f', component.options)
    }
    module.hot.accept("./VImage.vue?vue&type=template&id=3319612f&", function () {
      api.rerender('3319612f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/basic/VImage.vue"
export default component.exports